import React, { useEffect } from "react";
import "./Hives.css";
import rakshith from "../../Assets/hive/rak1.webp";
import meghana from "../../Assets/hive/meghana.webp";
import swati from "../../Assets/hive/swat.webp";
import parinitha from "../../Assets/hive/pranitha.webp";
import bhavani from "../../Assets/hive/bhavani.webp";
import gear from "../../Assets/gear.svg";
import compass from "../../Assets/compass.svg";
import har from "../../Assets/hive/harshita.webp";
import bhoomika from "../../Assets/hive/bhoomika.jpg";
import tanmayi from "../../Assets/hive/tanmayi.jpg";
import rak from "../../Assets/hive/rakshith-bnw.jpeg";
import eshwar from "../../Assets/hive/eshwar.jpeg";
import ish from "../../Assets/hive/ishwar.webp";
import shash from "../../Assets/hive/shashwatha.jpeg";
import neha from "../../Assets/hive/neha.jpeg";
import { Col, Container, Row } from "react-bootstrap";
function Hives() {
  useEffect(() => {
    let target = window.location.hash;
    target && document.querySelector(target).scrollIntoView();
  }, []);

  return (
    <div className="hives">
      <div id="hives" className="title">
        OUR HIVE
      </div>
      <Container className="rowContainer">
        <Row className="note">
          {/* <Col lg={4} className="colm">
            <div className="imgContainer">
              <img
                src={rakshith}
                width={290}
                height={290}
                alt="Rakshith"
                style={{ borderRadius: "40px" }}
              />
              <div className="name">Ar. Rakshith R</div>
              <div className="caps">Founder and Principal Architect</div>
              <div className="degree">
                B.Arch, School of Planning and Architecture
              </div>
              <div className="degree">University Of Mysore</div>
            </div>
          </Col> */}
          <div className="vectors">
            <div className="gear">
              <img
                src={gear}
                width={300}
                height={300}
                alt="gear"
                className="gear1"
              ></img>
              <img
                src={gear}
                width={300}
                height={300}
                alt="gear"
                className="gear2"
              ></img>
            </div>
          </div>
          <Col lg={8} className="noteContainer">
            <div className="noteTitle">Note from the Founder</div>
            <div className="content">
              Finding a balance between simplicity and design requirements is
              where we excel. We believe that in this balance one can find
              beauty and functionality.
              <br /> <br />
              At our studio, we believe simplicity strengthens design. <br /> We
              focus on clean forms, clear function, and thoughtful
              details—creating spaces that feel natural, work well, and look
              timeless. By choosing materials wisely and designing with the
              environment in mind, we aim to build spaces that are both
              practical and beautiful. Our simple, principle-driven approach
              helps us create designs that genuinely support everyday life.
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg={4} className="colm">
            <div className="imgContainer">
              <img
                src={rak}
                width={150}
                height={150}
                alt="Eshwar"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Rakshith R</div>
              <div className="caps">Founder and Principal Architect</div>
              <div className="degree">B.Arch, SPA_UOM</div>
              <div className="degree">Mysuru</div>
            </div>
          </Col>
          {/* <Col lg={2} className="colm">
            <div className="imgContainer">
              <img
                src={eshwar}
                width={150}
                height={150}
                alt="Eshwar"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Eshwar Chengappa</div>
              <div className="caps">Associate Architect</div>
              <div className="degree">B.Arch, SPA-UOM</div>
              <div className="degree">Mysuru</div>
            </div>
          </Col> */}

          {/* <Col lg={2} className="colm">
            <div className="imgContainer">
              <img
                src={shash}
                width={150}
                height={150}
                alt="Shaswatha M K"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Shaswatha M K</div>
              <div className="caps">Junior Architect</div>
              <div className="degree">B.Arch, SIT</div>
              <div className="degree">Tumkur</div>
            </div>
          </Col> */}
          <Col lg={4} className="colm">
            <div className="imgContainer">
              <img
                src={neha}
                width={150}
                height={150}
                alt="Ar. Neha S Kalshetty"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Neha S Kalshetty</div>
              <div className="caps">Associate Architect</div>
              <div className="degree">M.Arch, SPA_UOM</div>
              <div className="degree">Mysuru</div>
            </div>
          </Col>
          {/* <Col lg={2} className="colm">
            <div className="imgContainer">
              <img
                src={tanmayi}
                width={150}
                height={150}
                alt="Ar. Tanmayi R Koushik"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Tanmayi R Koushik</div>
              <div className="caps">Junior Architect</div>
              <div className="degree">B.arch , MSA</div>
              <div className="degree">Mysuru</div>
            </div>
          </Col> */}
          <Col lg={4} className="colm">
            <div className="imgContainer">
              <img
                src={bhoomika}
                width={150}
                height={150}
                alt="bhoomika"
                style={{ borderRadius: "5px" }}
              />
              <div className="name">Ar. Bhoomika SJ</div>
              <div className="caps">Senior Architect</div>
              <div className="degree">B.arch, M.S.R.I.T</div>
              <div className="degree">Mysuru</div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Hives;
